import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetPaginationSearchUrlDealerUseCase extends UseCase {
  constructor({getUrlSearchService, getPaginationSearchUrlDealerErrorFactory}) {
    super()
    this._getUrlSearchService = getUrlSearchService
    this._getPaginationSearchUrlDealerErrorFactory = getPaginationSearchUrlDealerErrorFactory
  }

  @inlineError
  async execute({search, queryPlaceholder, path, pageName}) {
    return this._getUrlSearchService
      .execute({
        queryPlaceholder,
        search,
        path,
        pageName
      })
      .then(url => {
        const encodedUrl = url && url.toJSON()
        return {
          url: decodeURI(encodedUrl?.url)
        }
      })
      .catch(error => Promise.reject(this._getPaginationSearchUrlDealerErrorFactory(error)))
  }
}
